import { useState } from "react";
import { TopInfo } from "../../components/top-info/top-info";
import { Toaster } from "react-hot-toast";
import Skills from "./components/skills-index";
import Charges from "./components/charges-index";
import Concepts from "./components/concepts-index";

const topInfo = { title: "Configuración Perfiles", subtitle: "Módulo de configuración de perfiles profesionales y competencias asociadas." };

const Params = () => {
  const [viewSelected, setViewSelected] = useState("profiles");

  return (
    <div className="gm-configurations-screen-container">
      <Toaster />
      <TopInfo info={topInfo} />
      <div className="gm-table-section-container">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            className={viewSelected === "profiles" ? "gm-ts-title" : "gm-ts-title-inactive"}
            onClick={() => {
              setViewSelected("profiles");
            }}
          >
            Perfiles Profesionales
          </div>
          <div
            className={viewSelected === "skills" ? "gm-ts-title" : "gm-ts-title-inactive"}
            onClick={() => setViewSelected("skills")}
          >
            Competencias
          </div>
          <div
            className={viewSelected === "concepts" ? "gm-ts-title" : "gm-ts-title-inactive"}
            onClick={() => setViewSelected("concepts")}
          >
            Competencias Bases
          </div>
        </div>
        </div>
      {viewSelected==="skills" && (
        <Skills />
      )}
      {viewSelected==="profiles" &&(
        <Charges />
      )}
      {viewSelected==="concepts" &&(
        <Concepts />
      )}
    </div>
  );
};

export default Params;
